<template>
   <g fill="none" stroke="currentColor">
      <path
         d="M13.9807 8.01596C13.882 9.25652 13.4292 10.4427 12.6762 11.4335C11.9231 12.4243 10.9015 13.1781 9.7326 13.6054C8.56371 14.0327 7.29673 14.1155 6.08217 13.844C4.86762 13.5724 3.75654 12.958 2.88095 12.0736C2.00535 11.1892 1.40205 10.072 1.14271 8.85485C0.883366 7.63769 0.978889 6.37166 1.41793 5.20718C1.85697 4.0427 2.62107 3.02872 3.61945 2.28571C4.61784 1.54269 5.80854 1.10187 7.05009 1.01562"
         stroke-linecap="round"
         stroke-linejoin="round"
      />
      <path
         d="M10.2891 8.59036C10.1085 9.05518 9.81488 9.46765 9.43479 9.79047C9.05471 10.1133 8.60014 10.3363 8.11221 10.4393C7.62427 10.5423 7.11835 10.5221 6.64021 10.3804C6.16206 10.2388 5.72676 9.98017 5.37368 9.62801C5.0206 9.27586 4.76087 8.84125 4.61798 8.36349C4.4751 7.88573 4.45355 7.37989 4.55531 6.89171C4.65706 6.40354 4.8789 5.94842 5.20076 5.56753C5.52262 5.18663 5.93436 4.89196 6.39873 4.71018M7.49883 7.50031L9.99907 5.00019M9.99907 5.00019L11.9993 5.50021L13.9994 3.50012L11.9993 3.00009L11.4992 1L9.49902 3.00009L9.99907 5.00019Z"
         stroke-linecap="round"
         stroke-linejoin="round"
      />
   </g>
</template>

<script>
export default {
   data() {
      return {
         name: 'icon-target',
         viewBox: '0 0 15 15',
         width: 15,
         height: 15,
         fill: 'none',
      };
   },
};
</script>
